
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Capa_1","version":"1.1","viewBox":"0 0 150 150","xml:space":"preserve","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('style',[_v('.st6{fill:#1e88e5}.st10{fill:#1565c0}')]),_c('rect',{attrs:{"width":"150","height":"150","rx":"16","ry":"16","fill":"#FFF"}}),_c('path',{staticClass:"st6",attrs:{"d":"M79.2 67.2l2.6 3.7 4-2.9v21h4.3V61.4h-3.6zM72.3 74.4c1.6-1.4 2.6-3.5 2.6-5.7 0-4.4-3.9-8-8.6-8-4 0-7.5 2.5-8.4 6.2l4.2 1.1c.4-1.7 2.2-2.9 4.2-2.9 2.4 0 4.3 1.6 4.3 3.6s-1.9 3.6-4.3 3.6h-2.5v4.4h2.5c2.7 0 5 1.9 5 4.1 0 2.3-2.2 4.1-4.9 4.1-2.4 0-4.5-1.5-4.8-3.6l-4.2.7c.7 4.1 4.6 7.2 9.1 7.2 5.1 0 9.2-3.8 9.2-8.5-.1-2.5-1.4-4.8-3.4-6.3z"}}),_c('path',{attrs:{"fill":"#fbc02d","d":"M100.2 120.3H49.8v-20.1h50.4z"}}),_c('path',{attrs:{"fill":"#4caf50","d":"M120.3 100.2V49.8h-20.1v50.4z"}}),_c('path',{staticClass:"st6",attrs:{"d":"M100.2 49.8V29.7h-63c-4.2 0-7.6 3.4-7.6 7.6v63h20.1V49.8h50.5z"}}),_c('path',{attrs:{"fill":"#e53935","d":"M100.2 100.2v20.1l20.1-20.1z"}}),_c('path',{staticClass:"st10",attrs:{"d":"M112.8 29.7h-12.6v20.1h20.1V37.2c0-4.2-3.3-7.5-7.5-7.5zM37.2 120.3h12.6v-20.1H29.7v12.6c0 4.2 3.3 7.5 7.5 7.5z"}})])
          )
        }
      }
    